import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Image } from '../../model/image';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SliderComponent implements OnInit {
  constructor() {}

  @Input() itemsSource: Image[];

  private _index: number = 0;
  get currentItem(): Image {
    if (this.itemsSource && this.itemsSource.length > 0) {
      return this.itemsSource[this._index];
    }
  }
  get canNavigate(): boolean {
    return this.itemsSource && this.itemsSource.length > 1;
  }

  clickLeft() {
    if (!this.itemsSource || this.itemsSource.length == 0) {
      return;
    }

    this._index -= 1;
    if (this._index < 0) {
      this._index = this.itemsSource.length - 1;
    }
  }

  clickRight() {
    if (!this.itemsSource || this.itemsSource.length == 0) {
      return;
    }

    this._index += 1;
    if (this._index >= this.itemsSource.length) {
      this._index = 0;
    }
  }

  ngOnInit() {}
}
